import Layout from './components/layout';
import Details from './components/ContractDetailsDailog';

export default {
	Layout,
	Details
}